import { useEffect, useRef, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { dapSubPages } from '../data/content';
import { SubPageIcon } from './icons';
import './LandingNavDropdown.css';

export function LandingNavDropdown() {
  const [open, setOpen] = useState(false);
  const location = useLocation();
  const wrapRef = useRef<HTMLDivElement>(null);

  // Close on route change.
  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  // Close when clicking outside.
  useEffect(() => {
    if (!open) return;
    function handleClick(event: MouseEvent) {
      if (wrapRef.current && !wrapRef.current.contains(event.target as Node)) {
        setOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [open]);

  return (
    <div className="landing-dd" ref={wrapRef}>
      <button
        type="button"
        className="landing-dd__trigger"
        aria-haspopup="true"
        aria-expanded={open}
        onClick={() => setOpen((prev) => !prev)}
      >
        What DAP-AI can do?
        <span className={`landing-dd__caret${open ? ' landing-dd__caret--up' : ''}`} aria-hidden>
          ▾
        </span>
      </button>

      {open && (
        <div className="landing-dd__menu" role="menu">
          {dapSubPages.map((sub) => (
            <Link
              key={sub.slug}
              to={sub.path}
              role="menuitem"
              className="landing-dd__item"
            >
              <span className="landing-dd__icon" aria-hidden>
                <SubPageIcon slug={sub.slug} />
              </span>
              {sub.label}
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
